import React, { createContext, useEffect, useState } from "react";
import { ReactNode } from "react";
import datatypes from "src/datatypes.json";
import { useApi } from "src/hooks/useApi";
import { ContextInfo } from "tsclient/V1";

type Environment = "dev" | "test" | "prod";

export interface DatatypeContextValue {
  datatype?: ContextInfo;
  env: Environment;
  contextInfos: ContextInfo[];
  setDatatype: (id: string) => void;
  setEnvironment: (type: Environment) => void;
}

interface DatatypeProviderProps {
  children?: ReactNode;
}

const defaultDatatype: ContextInfo = undefined;
const defaultEnv: Environment = "dev";

const DatatypeContext = createContext<DatatypeContextValue>({
  datatype: defaultDatatype,
  contextInfos: datatypes.datatypes,
  env: defaultEnv,
  setEnvironment: () => {},
  setDatatype: () => {},
});

export const DatatypeProvider: React.FC<DatatypeProviderProps> = ({
  children,
}) => {
  const { contextApi } = useApi();

  const [currentDatatype, setCurrentDatatype] = useState<
    ContextInfo | undefined
  >();
  const [contextInfos, setContextInfos] = useState<ContextInfo[]>();
  const [currentEnv, setCurrentEnv] = useState<Environment>(defaultEnv);

  useEffect(() => {
    const getContexts = async () => {
      const res = await contextApi.contextGet();
      if (res.contexts) {
        setContextInfos(res.contexts);

        setCurrentDatatype(res.contexts[0]);
      }
    };
    if (contextApi) {
      getContexts();
    }
  }, [contextApi]);

  const setDatatype = (id: string) => {
    const t = contextInfos.find((e) => e.id === id);
    if (t) {
      setCurrentDatatype(t);
    }
  };

  return (
    <DatatypeContext.Provider
      value={{
        datatype: currentDatatype,
        env: currentEnv,
        contextInfos,
        setEnvironment: setCurrentEnv,
        setDatatype,
      }}
    >
      {children}
    </DatatypeContext.Provider>
  );
};

export const DatatypeConsumer = DatatypeContext.Consumer;

export default DatatypeContext;
